import Stripe from 'stripe';

import type { CurrentPlanResponse } from 'src/services/api/studioCreditApi';

/**
 * The resolved plan as the minimal `Stripe.Price` the price-ID helpers in
 * PlansUtils read (id and recurring interval). The backend picks the plan item
 * past any add-ons, so this replaces reading `items.data[0]` off the raw
 * subscription. Studio intervals arrive as monthly/annual; Classic as Stripe's.
 */
export const planPriceFromCurrentPlan = (
  currentPlan?: CurrentPlanResponse,
): Stripe.Price | undefined => {
  if (!currentPlan?.planPriceId) {
    return undefined;
  }
  const interval =
    currentPlan.interval === 'annual' || currentPlan.interval === 'year'
      ? 'year'
      : 'month';
  return {
    id: currentPlan.planPriceId,
    recurring: { interval },
  } as Stripe.Price;
};
